// extracted by mini-css-extract-plugin
export default {"card":"zQ-z","defaultCard":"AQ-z","cardDetails":"BQ-z","cardActions":"CQ-z","separator":"DQ-z"};